import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Breadcrumbs, Button } from '@mui/material';

function IndexConfig() {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Configuración general';
    }, [auth])

    return (

        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Configuración General</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => {
                    if (card.auth.includes(auth.user.rol)) {
                        return (
                            <Grid item key={i} xs={12} sm={6} md={4}>
                                <CustomCard
                                    title={card.title}
                                    to={card.to}
                                    button={card.button}
                                    cardIco={card.cardIco}
                                    text={card.text}
                                    color={'primary.main'}
                                    btnColor={'primary'}
                                />
                            </Grid>
                        )
                    }
                    return null;
                })}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Editar Precios de Productos",
        text: "Cambia los precios de los productos con un factor de incremento",
        button: "Editar Precios",
        cardIco: "fad fa-file-invoice-dollar fa-3x",
        to: "/config/precios",
        auth: ['Admin']
    },
    {
        title: "Agregar y editar categorías",
        text: "Crea o modifica las categorías de los productos del almacén",
        button: "Categorias",
        cardIco: "fad fa-clipboard-list fa-3x",
        to: "/config/categorias",
        auth: ['Admin']
    },
    {
        title: "Gestionar Usuarios",
        text: "Crea o elimina usuarios del sistema",
        button: "Usuarios",
        cardIco: "fad fa-users-cog fa-3x",
        to: "/config/usuarios",
        auth: ['Admin']
    }
]

export default IndexConfig;